import React, {FC} from 'react';
import styled from 'styled-components';

import {Skeleton, SkeletonColorSchemesEnum} from '../../components/common/skeleton';
import {StyledSettingsContent, StyledSettingsMain, StyledSettingsWrapper} from '../common/settingsWrapper';
import {StyledCircleEditorContent} from './circleEditor';
import {CircleEditorHeader} from './circleEditorHeader';

/*
 * Props.
 */

interface CircleEditorSkeletonProps {
  isEditing: boolean;
}

/*
 * Style.
 */

const StyledSpacer = styled.div<{$marginBottom: string}>`
  margin-bottom: ${(p) => p.$marginBottom};
`;

const StyledTableSkeleton = styled(Skeleton)`
  height: 100%;
  margin-bottom: 76px;
  max-width: 708px;
`;

const StyledNameSkeleton = styled(Skeleton)`
  flex-shrink: 0;
`;

/*
 * Component.
 */

export const CircleEditorSkeleton: FC<CircleEditorSkeletonProps> = (props) => {
  const {isEditing} = props;

  return (
    <StyledSettingsWrapper>
      <CircleEditorHeader isEditing={isEditing} />
      <StyledSettingsMain>
        <StyledSettingsContent>
          <StyledCircleEditorContent>
            <StyledNameSkeleton width="75px" height="15px" scheme={SkeletonColorSchemesEnum.GREY30} />
            <StyledSpacer $marginBottom="8px" />
            <StyledNameSkeleton
              width="302px"
              height="30px"
              borderRadius="8px"
              scheme={SkeletonColorSchemesEnum.GREY10}
            />
            <StyledSpacer $marginBottom="32px" />
            <StyledNameSkeleton width="100px" height="15px" scheme={SkeletonColorSchemesEnum.GREY30} />
            <StyledSpacer $marginBottom="8px" />
            <StyledNameSkeleton
              width="302px"
              height="50px"
              borderRadius="8px"
              scheme={SkeletonColorSchemesEnum.GREY10}
            />
            <StyledSpacer $marginBottom="32px" />
            <StyledNameSkeleton width="175px" height="15px" scheme={SkeletonColorSchemesEnum.GREY30} />
            <StyledSpacer $marginBottom="20px" />
            <StyledNameSkeleton
              width="150px"
              borderRadius="999px"
              height="33px"
              scheme={SkeletonColorSchemesEnum.GREY10}
            />
            <StyledSpacer $marginBottom="24px" />
            <StyledTableSkeleton width="100%" scheme={SkeletonColorSchemesEnum.GREY10} />
          </StyledCircleEditorContent>
        </StyledSettingsContent>
      </StyledSettingsMain>
    </StyledSettingsWrapper>
  );
};
